import React from 'react'

class Admin extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(

        <React.Fragment>

            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">Admin</li>
                </ol>
            </nav>
            <div className="mt-4 p-5 bg-white text-black rounded text-center">
                <div className="container">
                    <h1 className="jumbotron-heading">Admin Page</h1>
                    <p>Here we can add all the lovely items for your shop, we can also adjust prices for things like 
                        <span className="text-danger"> INFLATION</span>, or down if we are nice</p>
                </div>
            </div>
            
            <div className="card-deck d-flex justify-content-center">
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Add more items.</h5>
                        <p className="card-text">Add a new item to the shop.</p>
                        
                    </div>
                    <div className="card-footer">
                        <a href="/add-items" className="btn btn-primary align-self-end justify-content-center">Continue</a>
                    </div>
                </div>
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Changes</h5>
                        <p className="card-text">Make changes to the stocked items</p>
                    </div>
                    <div className="card-footer">
                        {/* <a href="#" className="btn btn-primary align-self-end">Continue</a> */}
                    </div>
                </div>
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Special title treatment</h5>
                        <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                    </div>
                    <div className="card-footer">
                        {/* <a href="#" className="btn btn-primary align-self-end">Continue</a> */}
                    </div>                    
                </div>
            </div>


            <div className="card-deck d-flex justify-content-center">
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Spare feature</h5>
                        <p className="card-text">some text here</p>
                        
                    </div>
                    <div className="card-footer">
                        {/* <a href="#" className="btn btn-primary align-self-end justify-content-center">Continue</a> */}
                    </div>
                </div>
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Spare Feature</h5>
                        <p className="card-text">some text here</p>
                    </div>
                    <div className="card-footer">
                        {/* <a href="#" className="btn btn-primary align-self-end">Continue</a> */}
                    </div>
                </div>
                <div className="card admin-card m-3">
                    <div className="card-body admin-card-body">
                        <h5 className="card-title">Spare feature</h5>
                        <p className="card-text">some text here</p>
                    </div>
                    <div className="card-footer">
                        {/* <a href="#" className="btn btn-primary align-self-end">Continue</a> */}
                    </div>                    
                </div>
            </div>
        



         
        </React.Fragment>

    )}
}
export default Admin